module.exports = __webpack_public_path__ + "static/media/personThumb.5658a8ad.png";